import { useGetCompletedRooms } from 'src/features/public-profile/hooks';
import { RoomsTab } from '../rooms-tab/rooms-tab';
import { CompletedRoomsProps } from './completed-rooms.types';
export const CompletedRoomsTab = ({
  userId
}: CompletedRoomsProps) => <RoomsTab userId={userId} useRoomsHook={useGetCompletedRooms} emptyMessage="This user has not completed any rooms yet." data-sentry-element="RoomsTab" data-sentry-component="CompletedRoomsTab" data-sentry-source-file="completed-rooms-tab.tsx" />;